/// <amd-module name="Test/TestPlansHubRefresh/TestCaseLinkedItems/Redux/TestCaseLinkedItemsActions" />

import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { TestSuite } from "TestPlanCommon/Contracts/TestPlan";
import { ILinkedWorkItem } from "./TestCaseLinkedItemsContracts";

export const TestCaseLinkedItemsActions = {
    // dispatched to get initial data for the linked panel
    getInitialDataForLinkedPanel: (testCaseId: number, planId: number) =>
        createAction(TestCaseLinkedItemsActionsTypes.getInitialDataForLinkedPanel, { testCaseId, planId }),

    // dispatched to fetch linked test suites
    fetchLinkedTestSuites: (testCaseId: number) => createAction(TestCaseLinkedItemsActionsTypes.fetchLinkedTestSuites, { testCaseId }),

    // dispatched after fetchLinkedTestSuites succeeds to update the state
    fetchLinkedTestSuitesSucceeded: (testSuites: TestSuite[]) =>
        createAction(TestCaseLinkedItemsActionsTypes.fetchLinkedTestSuitesSucceeded, { testSuites }),

    // dispatched to get list of requirements/bugs linked to a test case
    fetchLinkedRequirementsOrBugs: (testCaseId: number, selectedTabId: string) =>
        createAction(TestCaseLinkedItemsActionsTypes.fetchLinkedRequirementsOrBugs, { testCaseId, selectedTabId }),

    // dispatched after fetchLinkedRequirementsOrBugs succeeds to update the state
    fetchLinkedRequirementsSucceeded: (requirements: ILinkedWorkItem[]) =>
        createAction(TestCaseLinkedItemsActionsTypes.fetchLinkedRequirementsSucceeded, { requirements }),

    // dispatched after fetchLinkedRequirementsOrBugs succeeds to update the state
    fetchLinkedBugsSucceeded: (bugs: ILinkedWorkItem[]) => createAction(TestCaseLinkedItemsActionsTypes.fetchLinkedBugsSucceeded, { bugs }),

    // dispatched to save the selected tab in the db through setting service
    saveSelectedTab: (selectedTabId: string) => createAction(TestCaseLinkedItemsActionsTypes.saveSelectedTab, { selectedTabId }),

    // dispatched after the last selected tab is retreived from the db
    changeSelectedTab: (selectedTabId: string) =>
        createAction(TestCaseLinkedItemsActionsTypes.changeSelectedTab, { selectedTabId }),
};

export const enum TestCaseLinkedItemsActionsTypes {
    getInitialDataForLinkedPanel = "TestCaseLinkedItems/getInitialDataForLinkedPanel",
    fetchLinkedTestSuitesSucceeded = "TestCaseLinkedItems/fetchLinkedTestSuitesSucceeded",
    fetchLinkedRequirementsOrBugs = "TestCaseLinkedItems/fetchLinkedRequirementsOrBugs",
    fetchLinkedRequirementsSucceeded = "TestCaseLinkedItems/fetchLinkedRequirementsSucceeded",
    fetchLinkedBugsSucceeded = "TestCaseLinkedItems/fetchLinkedBugsSucceeded",
    saveSelectedTab = "TestCaseLinkedItems/saveSelectedTab",
    changeSelectedTab = "TestCaseLinkedItems/changeSelectedTab",
    fetchLinkedTestSuites = "TestCaseLinkedItems/fetchLinkedTestSuites"
}

export type TestCaseLinkedItemsActions = ActionsUnion<typeof TestCaseLinkedItemsActions>;
